import { Loader2 } from "lucide-react";

export function LoadingScreen() {
  return (
    <div className="flex h-[100vh] w-full items-center justify-center bg-[#13110E]">
      <Loader2 className="h-8 w-8 animate-spin text-[#b08d57]" />
    </div>
  );
}
